<template>
  <h3
    class="title-image-container"
    :class="device.isMobile ? 'title-image-container-mobile' : ''"
    :id="content.key"
    :style="{
      fontFamily: content.textStyle.fontFamily || '',
      fontSize: (content.textStyle.fontSize + 'rem') || '',
      lineHeight: (content.textStyle.lineHeight + 'rem') || '',
      textIndent: (typeof content.textStyle.textIndent === 'string') ? content.textStyle.textIndent :
        (typeof content.textStyle.textIndent === 'number') ? (content.textStyle.textIndent + 'rem') : '',
      fontWeight: content.textStyle.fontWeight || '',
      textDecoration: content.textStyle.underline === 1 ? 'underline' : '',
      fontStyle: content.textStyle.fontItalic === 1 ? 'italic' : '',
      textAlign: content.textStyle.textAlign || '',
      color: content.textStyle.color || '',
      backgroundColor: content.textStyle.backgroundColor || '',
      backgroundImage: content.textStyle.backgroundImage ? `url(${content.textStyle.backgroundImage})` : '',
      marginTop: (content.textStyle.marginTop + 'rem') || '',
      marginBottom: (content.textStyle.marginBottom + 'rem') || '',
    }"
  >
    <img
      class="img"
      :id="`${content.key}-1`"
      :src="content.titleImage || require('@/assets/images/books/book1/title-back.png')"
      alt=""
      :style="{
        width: (content.titleImageWidth + 'rem') || '',
        margin: content.titleImagePosition === 'left' ? 0 : '',
      }"
    >
    <span class="text" :id="`${content.key}-2`" v-html="content.text"></span>
  </h3>
</template>
<script>
/*
标题-完整由图片构成的标题
*/
export default {
  name: "title-image",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title-image-container{
  width: calc(100% - 48rem);
  margin: 20rem auto;
  position: relative;

  .img{
    width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
  }

  .text{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
  }
}
.title-image-container-mobile{
  margin: 66rem auto 20rem;
}
</style>